import React from 'react';

import StackedLayout from 'app/components/layout/StackedLayout';
import Meta from 'app/features/landing/meta/components/Meta';
import HeroBlock from 'app/features/newLanding/components/HeroBlock';
import ProductComparison from 'app/features/newLanding/components/newProductComparison/ProductComparison';
import HelpCenter from 'app/features/helpCenter/components/HelpCenter';

const NewLanding = () => (
  <StackedLayout hasMarginTop>
    <Meta />
    <StackedLayout.ContentBlock isContained>
      <HeroBlock />
    </StackedLayout.ContentBlock>
    <StackedLayout.ContentBlock isContained>
      <ProductComparison />
    </StackedLayout.ContentBlock>
    <StackedLayout.ContentBlock>
      <HelpCenter />
    </StackedLayout.ContentBlock>
  </StackedLayout>
);

NewLanding.displayName = 'NewLanding';

export default NewLanding;
